<!-- Generator: Adobe Illustrator 28.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg enable-background='new 0 0 250 205' height='205px' version='1.1' viewBox='0 0 250 205' width='250px' x='0px'
     xml:space='preserve' xmlns='http://www.w3.org/2000/svg' y='0px'>
<g id="graphics">

		<path d="
		M86.5,12.5h-2v6.6c1.3,2.7,1.3,5.8,0,8.6v5.2l4.7,17.6H95l0.5-0.5v-3.2v-3.2V33.5h5.2h4.8v9.9v3.3V50l0.5,0.5h6.2l7.4-17.5l1.9-7.2
		V12.5h-7H86.5V2.9c2.6,1,5.2,2.1,7.9,1.9c2.6-0.1,5.3-1.3,7.9-1.2c2.1,0.1,4.1,1.1,6.3,1.5c2,0.4,4,0.2,6,0v7.3" fill="#DADADA" id="Werkzeugaufnahme_1_" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>
  <g id="Pfeil_Maschinenhöhe_x2F_Einbauhöhe_00000029729704271859587720000004077203807529090203_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="186.5" x2="186.5" y1="54.6" y2="191.4"/>
      <g>
				<polygon fill="#285172" points="184,55.3 186.5,51 189,55.3 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="184,190.7 186.5,195 189,190.7 				"/>
			</g>
		</g>
	</g>

  <line fill="none" id="Markierung_Einbauhöhe_unten_00000032622238383687224260000002079165929250438277_" stroke="#285172" stroke-miterlimit="10" x1="115" x2="190" y1="195.5" y2="195.5"/>

  <line fill="none" id="Markierung_verbleibende_Öffnung_00000061449396346031884960000001634732769450978945_" stroke="#285172" stroke-miterlimit="10" x1="115" x2="182" y1="158.5" y2="158.5"/>
  <g id="Pfeil_verbleibende_Öffnung_00000033351813909764875740000008767637141496869533_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="155.5" x2="155.5" y1="150.6" y2="154.4"/>
      <g>
				<polygon fill="#285172" points="153,151.3 155.5,147 158,151.3 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="153,153.7 155.5,158 158,153.7 				"/>
			</g>
		</g>
	</g>

  <line fill="none" id="Markierung_Oberwerkzeughöhe_oben_00000121961419853480024930000003488465582258725278_" stroke="#285172" stroke-miterlimit="10" x1="114" x2="190" y1="50.5" y2="50.5"/>

  <line fill="none" id="Markierung_Oberwerkzeughöhe_unten_00000014616966789922668810000010189765374054744497_" stroke="#285172" stroke-miterlimit="10" x1="102" x2="182" y1="146.5" y2="146.5"/>
  <g id="Pfeil_Oberwerkzeughöhe_ggf._mit_Adapter_00000165935279439263513630000014805674299512939140_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="176.5" x2="176.5" y1="54.6" y2="142.4"/>
      <g>
				<polygon fill="#285172" points="174,55.3 176.5,51 179,55.3 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="174,141.7 176.5,146 179,141.7 				"/>
			</g>
		</g>
	</g>

  <polygon fill="#9A9A9A" id="OW_00000073696177161848535870000013703339387308957346_" points="
		106.5,137.7 102.5,144.6 102.5,144.7 102.1,145.1 101.7,145.3 101.4,145.5 101,145.5 100.9,145.5 100.5,145.4 100.2,145.3
		99.8,145 99.5,144.6 95.5,137.7 95.5,62.3 95.5,86 95.5,62.7 87.5,54.9 87.5,50.5 95.8,50.5 95.9,50.3 95.5,50.3 95.5,43.1
		97.5,41.6 97.5,41 95.5,39.4 95.5,34.1 96.4,33.5 104.4,33.5 105.5,34.1 105.5,39.4 103.5,41 103.5,41.6 105.5,43.1 105.5,50.3
		104.9,50.3 104.9,50.5 113.5,50.5 113.5,54.9 106.5,62.7 106.5,86 	" stroke="#707070" stroke-miterlimit="10"/>

  <polygon fill="#9A9A9A" id="UW_00000139984449482080462130000016496910482655705530_" points="
		114.5,158.9 114.1,158.5 113.2,158.5 112.9,158.5 112.7,158.6 112.4,158.7 112.1,158.8 111.9,159 111.8,159.2 102,170.8
		101.7,171.1 101.4,171.2 101.2,171.4 100.9,171.5 100.7,171.5 100.4,171.5 100.1,171.5 99.9,171.4 99.6,171.2 99.4,171.1
		99.1,170.8 89.3,159.2 89.1,158.9 88.8,158.7 88.5,158.6 88.3,158.5 88,158.5 87.9,158.5 86.9,158.5 86.5,158.9 86.5,196.5
		98.3,196.5 98.3,196.5 98.4,196.6 98.5,196.6 98.5,196.7 98.5,203.2 98.9,203.5 102.1,203.5 102.5,203.2 102.5,196.7 102.5,196.6
		102.6,196.6 102.6,196.5 102.7,196.5 114.5,196.5 114.5,184 	" stroke="#707070" stroke-miterlimit="10"/>
  <g id="Pfeil_Unterwerkzeughöhe_00000005233482691722611680000005249979617993628828_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="78.5" x2="78.5" y1="192.4" y2="162.6"/>
      <g>
				<polygon fill="#285172" points="81,191.7 78.5,196 76,191.7 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="80.9,163.3 78.4,159 76,163.3 				"/>
			</g>
		</g>
	</g>
</g>
  <g id="texts">
	<rect fill="none" height="29.7" width="56.8" x="125.1" y="161"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="desiredRemainingOpening" transform="matrix(1 0 0 1 133.1884 169.8818)">{{desiredRemainingOpening}}</text>
    <rect fill="none" height="36" width="56.8" x="191" y="112.7"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="minimalMountHeight" transform="matrix(1 0 0 1 190.9999 121.583)">{{minimalMountHeight}}</text>
    <rect fill="none" height="36" width="66" x="3.2" y="163.7"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="bottomToolHeight" transform="matrix(1 0 0 1 17.2411 172.5368)">{{bottomToolHeight}}</text>
    <rect fill="none" height="36" width="59" x="114" y="80"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="upperToolHeight" transform="matrix(1 0 0 1 122.3876 88.862)">{{upperToolHeight}}</text>
</g>
</svg>
